import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { CodeProjectService } from '../code-project.service';
import { CodeProject } from '../code-project';
import { CodeProjectComponent } from '../code-project/code-project.component';
import * as moment from 'moment';
import { CodeTaskService } from '@app/_components/code-task/code-task.service';

@Component({
    selector: 'app-code-project-list',
    templateUrl: './code-project-list.component.html',
    styleUrls: ['./code-project-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class CodeProjectListComponent implements OnInit {
	categories: any;
	codeTasks: any[]=[];
	constructor(
		private codeProjectService: CodeProjectService,
		private codeTaskService: CodeTaskService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = codeProjectService.statuses;
		this.categories = codeProjectService.categories;
	}



	// data
	codeProjects: any;
	codeProject: CodeProject;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'projectName', header: 'Project Name', width: 'auto' },
		{ field: 'assignedTo', header: 'Assigned To', width: 'auto' },
		{ field: 'category', header: 'Category', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'assignedDate', header: 'Assigned Date', width: 'auto' },
		{ field: 'taskCount', header: 'Total Task', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			this.fetchCodeTasks();
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.codeProjectId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-codeProject-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.codeProjectService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.codeProjects = res.data.codeProjects;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.codeProjects = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(codeProject: CodeProject) {
		try {
			this.formLoading = true;
			this.codeProjectService.update(codeProject)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.codeProjects.map((codeProject, i) => {
							if (codeProject.codeProjectId === res.data.codeProject.codeProjectId) {
								this.codeProjects[i] = res.data.codeProject;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(codeProject: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(codeProject));

			this.formLoading = true;
			this.codeProjectService.delete(codeProject.codeProjectId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.codeProjects.splice(this.codeProjects.indexOf(codeProject), 1);
						this.recordTotal = this.codeProjects.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'CodeProject ' + codeProject.codeProjectId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'CodeProject ' + codeProject.codeProjectId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add CodeProject'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CodeProjectComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				this.fetchCodeTasks();
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addCodeProjectCB(data);
				
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				//dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(codeProject: CodeProject) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			codeProject: codeProject,
			title: 'Edit CodeProject'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CodeProjectComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				this.fetchCodeTasks();
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateCodeProjectCB(data);
				
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteCodeProjectCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addCodeProjectCB(codeProject: CodeProject) {
		console.log('Adding CodeProject: ' + JSON.stringify(codeProject));
		// if we don't have a codeProjects array yet...
		if (!this.codeProjects) {
			this.codeProjects = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.codeProjects.unshift(codeProject);

		// no idea what this is but it is required to update the array
		this.codeProjects = [...this.codeProjects];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CodeProject ' + codeProject.codeProjectId + ' Added', life: 3000 });
	}

	updateCodeProjectCB(codeProject: CodeProject) {
		console.log('Updating CodeProject: ' + JSON.stringify(codeProject));
		let itemIndex = this.codeProjects.findIndex((item: any) => item.codeProjectId === codeProject.codeProjectId);
		this.codeProjects[itemIndex] = codeProject;

		// no idea what this is but it is required to update the array
		this.codeProjects = [...this.codeProjects];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CodeProject ' + codeProject.codeProjectId + ' Updated', life: 3000 });
	}

	deleteCodeProjectCB(codeProject: CodeProject) {
		console.log('Removing CodeProject: ' + codeProject);
		this.codeProjects.splice(this.codeProjects.indexOf(codeProject), 1);
		this.recordTotal = this.codeProjects.length;

		// no idea what this is but it is required to update the array
		this.codeProjects = [...this.codeProjects];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CodeProject ' + codeProject.codeProjectId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.codeProjects ? this.first === (this.codeProjects.length - this.rows) : true; }
	isFirstPage(): boolean { return this.codeProjects ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(codeProject: any) {
		if (codeProject?.status) {
			const status = this.statuses.find((e: any) => e.value == codeProject.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	getResStatusColor(resStatus: any) {
		console.log("resStatus :" + resStatus);
		if (resStatus === "open") {
			return '#f5af2f';
		}
		if (resStatus === "inprogress") {
			return '#7eede6';
		}
		if (resStatus === "complete") {
			return '#2ae024';
		}
		if (resStatus === "readyforreview") {
			return '#707ce6';
		}
		if (resStatus === "onhold") {
			return '#c44f91';
		}
		if (resStatus === "realeased") {
			return '#addb16';
		}
	}

	getCategoryName(codeProject: any) {
		if (codeProject?.category) {
			const status = this.categories.find((e: any) => e.value == codeProject.category);
			return status.name;
		}
		else {
			return '';
		}
	}

	// formate assigned to date
	formateAssignedToDate(assignedTo: any) {
		return moment.utc(assignedTo).format('MM/DD/YYYY');;
	}
	
	// get all code task
	fetchCodeTasks() {
		try {
			this.codeTaskService.getAllTask()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.codeTasks = res.data.codeTasks;
						console.log('this.codeTasks: ' + JSON.stringify(this.codeTasks));
						return this.codeTasks;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	
	totalTaskCount(codeProjectId: any) {
		let count= 0;
		this.codeTasks.forEach(codeTask=> {
            if(codeTask.codeProjectId == codeProjectId){
				count = count + 1;
			}
         });
		return count;
	}
}
